import {isSafeInteger} from "lodash"

export interface BasketTotals {
  vat: number
  total: number
  discount: number
  subtotal: number
  currency: string
  isOpenValue: boolean
  hasSelectedAProduct?: boolean
}

export default function calculateTotals(basket: any, walletBalanceToUse?: number): BasketTotals {
  const breakdown = basket.breakdown
  const currency = breakdown.total.currency
  const subtotal = breakdown.total.amount + breakdown.total.serviceCharge
  const discount = breakdown.total.originalPrice - subtotal
  const total = subtotal - (walletBalanceToUse || 0)
  const vat = breakdown.total.vat
  const isOpenValue = isSafeInteger(basket.items[0]?.item?.openValue)

  return {
    vat,
    total,
    discount,
    subtotal,
    currency,
    isOpenValue,
    hasSelectedAProduct: (basket.items?.length || 0) !== 0
  }
}
